import {Injectable} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {FactOfTheDay, IFactOfTheDay} from './DataModels/FactOfTheDay';
import {BackendService} from './backend.service';
import {sameDay} from './helpers/helpers';
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root'
})
export class FactOfTheDayService {

  public factOfTheDay: FactOfTheDay;
  public last5FactsOfTheDay: FactOfTheDay[] = [];

  public serviceReady: boolean = false;
  public serviceReadySubject: Subject<boolean> = new Subject<boolean>();

  private _todayReady: boolean = false;
  private _last5Ready: boolean = false;
  private _lastUpdated: Date;
  private _userServiceReadySubscription: Subscription;

  constructor(private backend: BackendService, private userService: UserService) {
    this.waitForUserServiceIsReady();
  }

  public update(): void {
    // if(this._lastUpdated){
    //   if(sameDay(this._lastUpdated, new Date())) return;
    // }
    // this.loadFactOfTheDayFromBackend();
    // this.loadLast5FactsOfTheDayFromBackend();
  }

  //method which loads today's fact of the day from backend
  private loadFactOfTheDayFromBackend() {
    this.backend.getFactOfTheDay()
        // resp is of type `HttpResponse<IFactOfTheDay>`
        .subscribe({
          next: resp => {
            // display its headers
            const keys = resp.headers.keys();
            var headers = keys.map(key =>
                `${key}: ${resp.headers.get(key)}`);
            console.log("Status: " + resp.status);
            // access the body directly, which is typed as `IFactOfTheDay`.
            var iFactOfTheDay: IFactOfTheDay = {...resp.body};
            if (iFactOfTheDay) {
              this.factOfTheDay = new FactOfTheDay(iFactOfTheDay);
              console.log(this.factOfTheDay);
            }
            this._todayReady = true;
            this.serviceIsReady();
            this._lastUpdated = new Date();
          },
          error: err => {
            console.log(err);
            this._todayReady = true;
            this.serviceIsReady();
          }
        });
  }

  //method which loads the last 5 facts of the day from backend
  private loadLast5FactsOfTheDayFromBackend() {
    this.backend.getLastXFactsOfTheDay(5)
        // resp is of type `HttpResponse<IFactOfTheDay[]>`
        .subscribe({
          next: resp => {
            console.log("Status: " + resp.status);
            // access the body directly, which is typed as `IFactOfTheDay[]`.
            var iFactsOfTheDay: IFactOfTheDay[] = [...resp.body];
            if (iFactsOfTheDay) {
              this.last5FactsOfTheDay = [];
              iFactsOfTheDay.forEach(iFactOfTheDay => {
                this.last5FactsOfTheDay.push(new FactOfTheDay(iFactOfTheDay));
              });
            }
            this._last5Ready = true;
            this.serviceIsReady();
            this._lastUpdated = new Date();
          },
          error: err => {
            console.log(err);
            this._last5Ready = true;
            this.serviceIsReady();
          }
        });
  }

  //This method is called after fact of the day was loaded from backend
  private serviceIsReady() {
    if (this.serviceReady) return;
    if (!this._todayReady || !this._last5Ready) return;
    this.serviceReady = true;
    this.serviceReadySubject.next(true);
    console.log("FactOfTheDayService is ready!");
  }

  private waitForUserServiceIsReady(): void {
    if (this.userService.serviceReady) {
      this.update();
    } else {
      this._userServiceReadySubscription = this.userService.serviceReadySubject.subscribe((val: boolean) => {
        if (val) {
          this.update();
          this._userServiceReadySubscription.unsubscribe();
        }
      });
    }
  }
}
